import React, { Component } from "react";

import ProjPeopleContent from "../../ProjPeopleContent";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

const projTeam = {
  header: [
    "Deputy Project Director",
    "Principal Investigator",
    "Co-investigators",
    "Team Lead",
    "Team Members",
    "Research Scientists",
    "Research Fellows",
  ],
  rows: {
    row1: [
      "Shri. K. Abdul Hakeem, Head, WRID",
      "Dr. K. Chandrasekar, Head, AppIns, RC ",
      "Sri. J. Mohamed Ahmed, S/E 'SE', RC (South)",
      "",
      "",
      "Sri. Madhavi P  RS (WR)",
      "Ms. P Krishna Bhargavi JRF (WR)",
    ],
    row2: ["", "", "Smt. Nidhi Misra,  S/E 'SE', WRID, WRG", "", "", "", " "],
    row3: ["", "", "Sri. Anurag  Mishra, S/E 'SC', WRID, WRG", "", "", "", ""],
  },
};
export default class ETProjTeam extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "500px" }}>
              <main style={{ flexGrow: "1", overflowX: "auto" }}>
                <div className="card" style={{ width: "100%", height: "100%" }}>
                  <div className="card-body">
                    <ProjPeopleContent data={projTeam} width="80%" />
                  </div>
                </div>
              </main>
            </div>
          </main>
          {/* </MDBCardBody>
        </MDBCard> */}
        </div>
      </div>
    );
  }
}
